import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../App.css";
import LiveChat from "../components/LiveChat";
import QAChatbot from "../components/QAChatBot";
import BackToTopButton from "../components/BackToTopButton";
import ScrollSocialIcons from "../components/ScrollSocialIcons";
import GetQuoteButton from "../components/GetQuoteButton";

const jobOpenings = [
  {
    id: 8,
    title: "Trainee / Junior Marketing Executive",
    location: "Colombo, Sri Lanka",
    type: "Full-Time, On-site",
    description: "The role involves executing marketing strategies, managing social media platforms, creating and optimizing web content, monitoring performance through analytics tools and collaborating with the team to ensure effective campaign delivery.",
    responsibilities: [
      "Assist in planning and executing marketing campaigns across digital and traditional channels",
      "Support social media management (content creation, scheduling, engagement and monitoring)",
      "Conduct market research to identify trends",
      "Help create marketing materials, including brochures, presentations and email campaigns",
      "Coordinate with internal teams and external vendors (designers, agencies, printers etc.)",
      "Handle basic administrative tasks related to marketing activities"
    ],
    requirements: [
      "Basic Skills in photography and videography",
      "Prior internship or work experience in marketing or a related field",
      "Basic knowledge of graphic design tools (e.g. Canva, Adobe Photoshop, Adobe Illustrator)",
      "Familiarity with digital marketing tools (Google Analytics, SEO, email marketing platforms)"
    ]
  },
  {
    id: 9,
    title: "Trainee / Junior Estimation & Invoicing Engineer",
    location: "Colombo, Sri Lanka",
    type: "Full-Time, On-site",
    description: "Responsible for supporting the project and finance teams by preparing accurate cost estimates, managing invoicing processes, and ensuring timely documentation for smooth project execution.",
    responsibilities: [
      "Prepare cost estimates and quotations for Marine Repair and Maintenance projects",
      "Analyze technical specifications, drawings, and client requirements",
      "Coordinate with engineering and operations teams to gather necessary project details",
      "Prepare and process invoices in line with project progress and contractual terms",
      "Monitor project costs and assist in budget tracking and cost control",
      "Maintain accurate records of estimates, invoices, and related documentation"
    ],
    requirements: [
      "Diploma or Degree in Marine Engineering, Mechanical Engineering, or a related field",
      "Basic knowledge of marine repair processes, ship systems, or industrial maintenance",
      "Strong numerical and analytical skills",
      "Good understanding of costing, estimation, and invoicing procedures",
      "Proficiency in Microsoft Office (especially Excel)",
      "Strong attention to detail and accuracy",
      "Good communication and interpersonal skills",
      "Ability to work under pressure and meet deadlines"
    ]
  },
  {
    id: 10,
    title: "Trainee / Junior IT Engineer (Fresh Graduate)",
    location: "Colombo, Sri Lanka",
    type: "Full-Time, On-site",
    description: "Supporting IT operations, maintaining hardware and software systems, troubleshooting technical issues, monitoring network performance, and collaborating with the IT team to ensure smooth and secure technology operations.",
    responsibilities: [
      "Assist in maintaining IT systems, networks and hardware",
      "Support troubleshooting and resolving technical issues",
      "Work with software, systems, and basic networking tasks",
      "Provide technical support to internal teams"
    ],
    requirements: [
      "Fresh graduate in IT, Computer Science, or related field",
      "Basic knowledge of networking, hardware and software systems, maintain Website and Software Languages",
      "Good communication and interpersonal skills",
      "Ability to work under pressure and meet deadlines"
    ]
  },
  {
    id: 11,
    title: "Policy Making - Intern",
    location: "Colombo, Sri Lanka",
    type: "Full-Time, On-site",
    description: "Become part of our expanding team where your ideas and research will help shape real-world policies.",
    responsibilities: [
      "Conduct research on policies, regulations, and best practices relevant to our projects",
      "Assist in drafting policy proposals, briefs, and reports",
      "Analyze the impact of existing or proposed policies and prepare summaries for internal review",
      "Support stakeholder engagement, including organizing meetings and collecting feedback",
      "Track policy implementation progress and help maintain documentation",
      "Assist the policy team with day-to-day administrative and research tasks"
    ],
    requirements: [
      "Currently pursuing a Bachelor's or master's degree in political science, Public Policy, International Relations, Economics, Law, or a related field",
      "Strong research, analytical, and problem-solving skills",
      "Excellent written and verbal communication skills",
      "Proficiency in Microsoft Office or Google Workspace",
      "Detail-oriented, organized, and able to handle multiple tasks simultaneously",
      "Passion for policy-making, governance, or public affairs"
    ]
  },
  {
    id: 4,
    title: "Senior Marine - Welder",
    location: "Athurugiriya, Sri Lanka",
    type: "Full-Time",
    description: "CIAP (PVT) LTD is looking for an experienced Senior Marine Welder to join our specialized engineering team.",
    requirements: [
      "Minimum 5 years of experience in the welding field",
      "Aluminum Welding experience is considered a significant plus point",
      "Ability to work in marine environments and follow strict safety protocols"
    ]
  },
  {
    id: 5,
    title: "Senior Technician",
    location: "Athurugiriya, Sri Lanka",
    type: "Full-Time",
    description: "We are recruiting for a Senior Technician with seafaring or power plant experience to support our technical operations.",
    requirements: [
      "Sailing experience as an Oiler / Wiper or experience in Power Plants",
      "Minimum 2 years of Sea experience or experience in a related industry",
      "Strong mechanical aptitude and troubleshooting skills"
    ]
  },
{id:6,title:"Assistant HR Manager", location: "Athurugiriya, Sri Lanka",type: "Full-Time",
    description: "WE’RE HIRING! Assistant HR Manager CIAP (PVT) LTD is a Sri Lankan-based company providing Total Marine & Engineering Solutions globally. We offer exciting career growth opportunities in a rapidly expanding organization. We are looking for an energetic, motivated, and dedicated professional who is willing to go the extra mile.We are currently recruiting for the position of Assistant HR Manager at CIAP (PVT) LTD.",
    requirements: [
      "Minimum 4 years of experience in an HR Executive role",
      "or",
      "Minimum 1 year of experience in an Assistant HR Manager role",
      "Bachelor’s Degree in Human Resources, Business Administration, or a related field",
      "We offer a competitive salary package along with excellent opportunities for professional growth and career advancement within the industry.",
      "If you are looking to join a dynamic and fast-growing company, we encourage you to apply for the position of Assistant HR Manager at CIAP (PVT) LTD."
    ]
  },

];

const Join = () => {
  return (
    <div>
      <Navbar />
      <div className="career-page">
        <section className="career-intro">
          <h1>Join Our Team</h1>
          <p>
            At CIAP, we believe in Innovation, Integrity and Impactful
            Engineering. We're looking for talented, driven individuals to join
            our diverse teams across Marine, Pre-Dock, Boat/Shipbuilding,
            Husbandry, and Industry Services sectors. If you're passionate about
            excellence and want to work in a collaborative environment, explore
            our current openings below.
          </p>
        </section>

        <section className="job-listings">
          <h2>Current Job Openings</h2>
          {jobOpenings.map((job) => (
            <div key={job.id} className="job-card">
              <h3>{job.title}</h3>
              <p className="job-meta">
                {job.location} | {job.type}
              </p>

              {/* Job Description */}
              <p className="job-description">{job.description}</p>

              {/* Responsibilities (if present) */}
              {job.responsibilities && (
                <div className="job-responsibilities">
                  <h4>Key Responsibilities:</h4>
                  <ul>
                    {job.responsibilities.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Candidate Requirements */}
              {job.requirements && (
                <div className="candidate-criteria">
                  <h4>Candidate Requirements:</h4>
                  <ul>
                    {job.requirements.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Apply Now Button */}
              <Link to={`/apply/${job.id}`} className="apply-btn">
                Apply Now
              </Link>
            </div>
          ))}
        </section>

        <LiveChat />
        <QAChatbot />
        <ScrollSocialIcons />
        <GetQuoteButton />
        <BackToTopButton />
        <Footer />
      </div>
    </div>
  );
};

export default Join;